// getLivestreamMode.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

import getLiveStreamData from '../selector/getLiveStreamData.js';

/**
 * Select the livestream mode as the session reports it.
 *
 * One source: the session snapshot at `[streamId, 'metadata']`. Both producers
 * write there — the room's own snapshot via `action/handleSessionStatusChange.js`,
 * and the feed's per-livestream detail via
 * `action/handleFeedsLivestreamChanged.js` — so a feed card and a room read
 * the same value by the same path.
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} streamId - stream id.
 * @return {string} The reported LivestreamMode, or undefined before the first
 * snapshot lands.
 */
const getLivestreamMode = createCachedSelector(
  (state, streamId) => getLiveStreamData(state, [streamId, 'metadata'], 'mode'),
  mode => mode
)((state, streamId) => `${streamId}`);

export default getLivestreamMode;
